export const LEFT_BORDER_6H_IN_MINUTES = 60 * 6;
export const BORDER_24H_IN_MINUTES = 60 * 24;
export const BORDER_48H_IN_MINUTES = 60 * 48;
export const RIGHT_BORDER_18H_IN_MINUTES = 60 * 18;
export const RANGE_MAX_MINUTES_IN_24H = 60 * 24;
export const RANGE_MIN_MINUTES_IN_24H = 0;
